/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=3d065c56&scoped=true"
import script from "./AppModal.ts?vue&type=script&lang=js&external"
export * from "./AppModal.ts?vue&type=script&lang=js&external"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=3d065c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d065c56",
  null
  
)

export default component.exports